module.exports = __webpack_public_path__ + "media/site/images/startups/tatralife-desktop-48271b331baa5fb8223eb589c09ef3c7.png";